import { SignIn, useAuth } from '@clerk/clerk-react';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const navigateBack = () => {
    const searchParams = new URLSearchParams(location.search);
    const returnTo = searchParams.get('return_to') || '/';
    navigate(returnTo, { replace: true });
  };

  if (isSignedIn) {
    navigateBack();
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 p-4">
      <div className="relative w-full max-w-xs rounded-2xl bg-white">
        <SignIn />
      </div>
    </div>
  );
};

export default Login;
